import { FecThirdPartyCategory } from '../enums/fecThirdPartyCategory'
import { FecThirdPartyStatus } from '../enums/fecThirdPartyStatus'
import type { FecThirdPartyMappingItem } from '../query-api'
import type { FecThirdPartyMapping } from '../types/fecThirdPartyMapping'

const getStatus = (category: FecThirdPartyCategory): FecThirdPartyStatus =>
  category === FecThirdPartyCategory.Create ? FecThirdPartyStatus.New : FecThirdPartyStatus.Existing

export const toFecThirdPartyMappings = (
  items: FecThirdPartyMappingItem[],
  fecImportId: string,
): FecThirdPartyMapping[] =>
  items.map((item) => ({
    accountNo: item.auxAccountNo,
    fecImportId,
    id: item.id,
    label: item.auxLabel,
    role: item.detectedType,
    status: getStatus(item.category),
  }))
